<script setup lang="ts">
const { t } = useI18n();

const navigation = computed(() => [
  { name: t('nav.features'), href: "/#fonctionnalites" },
  { name: t('nav.contracts'), href: "/contrat-en-ligne" },
  { name: t('nav.pricing'), href: "/#tarifs" },
  { name: t('nav.faq'), href: "/#faq" },
  // { name: "Blog", href: "/blog" },
]);

const mobileMenuOpen = ref(false);
</script>

<template>
  <header class="absolute inset-x-0 top-0 z-50">
    <nav
      class="flex items-center justify-between p-6 lg:px-8"
      aria-label="Global"
    >
      <div class="flex lg:flex-1">
        <Logo to="/" />
      </div>
      <div class="flex lg:hidden">
        <button
          type="button"
          class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          @click="mobileMenuOpen = true"
        >
          <span class="sr-only">{{ $t('nav.openMenu') }}</span>
          <Icon
            name="heroicons:bars-3"
            class="size-6"
            aria-hidden="true"
          />
        </button>
      </div>
      <div class="hidden lg:flex lg:gap-x-12">
        <NuxtLinkLocale
          v-for="item in navigation"
          :key="item.name"
          :to="item.href"
          class="text-sm font-semibold leading-6 text-gray-900"
        >{{ item.name }}</NuxtLinkLocale>
      </div>
      <div class="hidden lg:flex lg:flex-1 lg:justify-end">
        <NuxtLinkLocale
          to="/app"
          class="text-sm font-semibold leading-6 text-gray-900"
        >
          <LazyAuthState>
            <template #default="{ loggedIn }">
              {{ loggedIn ? $t('common.useApp') : $t('common.login') }} <span aria-hidden="true">&rarr;</span>
            </template>
            <template #placeholder>
              {{ $t('common.login') }} <span aria-hidden="true">&rarr;</span>
            </template>
          </LazyAuthState>
        </NuxtLinkLocale>
      </div>
    </nav>
    <HeadlessDialog
      class="lg:hidden"
      :open="mobileMenuOpen"
      @close="mobileMenuOpen = false"
    >
      <div class="fixed inset-0 z-50" />
      <HeadlessDialogPanel class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div class="flex items-center justify-between">
          <Logo
            class="-m-1.5 p-1.5"
            to="/"
            @click="mobileMenuOpen = false"
          />
          <button
            type="button"
            class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            @click="mobileMenuOpen = false"
          >
            <span class="sr-only">{{ $t('nav.closeMenu') }}</span>
            <Icon
              name="heroicons:x-mark"
              class="size-6"
              aria-hidden="true"
            />
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 py-6">
              <NuxtLinkLocale
                v-for="item in navigation"
                :key="item.name"
                :to="item.href"
                class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                @click="mobileMenuOpen = false"
              >
                {{ item.name }}
              </NuxtLinkLocale>
            </div>
            <div class="py-6">
              <NuxtLinkLocale
                to="/app"
                class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                @click="mobileMenuOpen = false"
              >
                <LazyAuthState>
                  <template #default="{ loggedIn }">
                    {{ loggedIn ? $t('common.useApp') : $t('common.login') }} <span aria-hidden="true">&rarr;</span>
                  </template>
                  <template #placeholder>
                    {{ $t('common.login') }} <span aria-hidden="true">&rarr;</span>
                  </template>
                </LazyAuthState>
              </NuxtLinkLocale>
            </div>
          </div>
        </div>
      </HeadlessDialogPanel>
    </HeadlessDialog>
  </header>
</template>
